import * as uuid from 'uuid';
import { getSystemRoleId } from './uuid.const.js';
export const SYSTEM_ROLE_NAME_ALL = 'all';
export const SYSTEM_ROLE_NAME_SYSTEM = 'system';
export const SYSTEM_ROLE_NAME_RESELLER = 'reseller';
export const SYSTEM_ROLE_NAME_ACCOUNT = 'account';
export const AUTOMATIC_ROLE_NAME_GUEST = 'guest';
export const AUTOMATIC_ROLE_NAME_MEMBER = 'member';
export const SYSTEM_ROLE_NAMES = [
    SYSTEM_ROLE_NAME_SYSTEM,
    SYSTEM_ROLE_NAME_RESELLER,
    SYSTEM_ROLE_NAME_ACCOUNT,
];
export const AUTOMATIC_ROLE_NAMES = [
    AUTOMATIC_ROLE_NAME_GUEST,
    AUTOMATIC_ROLE_NAME_MEMBER,
];
export const ALL_ROLE = {
    _id: uuid.NIL,
    name: SYSTEM_ROLE_NAME_ALL,
    title: 'Any User Role',
    domain: uuid.NIL,
    active: true,
    deleted: false,
};
export const SYSTEM_ROLES_MAP = {
    [SYSTEM_ROLE_NAME_SYSTEM]: {
        _id: getSystemRoleId(SYSTEM_ROLE_NAME_SYSTEM),
        name: SYSTEM_ROLE_NAME_SYSTEM,
        title: 'System Administrator',
        domain: uuid.NIL,
        active: true,
        deleted: false,
    },
    [SYSTEM_ROLE_NAME_RESELLER]: {
        _id: getSystemRoleId(SYSTEM_ROLE_NAME_RESELLER),
        name: SYSTEM_ROLE_NAME_RESELLER,
        title: 'Reseller Administrator',
        domain: uuid.NIL,
        active: true,
        deleted: false,
    },
    [SYSTEM_ROLE_NAME_ACCOUNT]: {
        _id: getSystemRoleId(SYSTEM_ROLE_NAME_ACCOUNT),
        name: SYSTEM_ROLE_NAME_ACCOUNT,
        title: 'Account Administrator',
        domain: uuid.NIL,
        active: true,
        deleted: false,
    },
    [AUTOMATIC_ROLE_NAME_GUEST]: {
        _id: getSystemRoleId(AUTOMATIC_ROLE_NAME_GUEST),
        name: AUTOMATIC_ROLE_NAME_GUEST,
        title: 'Anonymous Citizen',
        domain: uuid.NIL,
        active: true,
        deleted: false,
    },
    [AUTOMATIC_ROLE_NAME_MEMBER]: {
        _id: getSystemRoleId(AUTOMATIC_ROLE_NAME_MEMBER),
        name: AUTOMATIC_ROLE_NAME_MEMBER,
        title: 'Registered Citizen',
        domain: uuid.NIL,
        active: true,
        deleted: false,
    },
};
export const SYSTEM_ADMINISTRATOR_ROLE_NAMES = [SYSTEM_ROLE_NAME_RESELLER, SYSTEM_ROLE_NAME_SYSTEM];
export const ACCOUNT_ADMINISTRATOR_ROLES_NAMES = [SYSTEM_ROLE_NAME_ACCOUNT];
export const MEMBER_ROLE_NAMES = [AUTOMATIC_ROLE_NAME_MEMBER];
